// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { Attributor } = Quill.import('parchment');

/**
 * This attributor is for attributes which are not strings (e.g. arrays or objects) and therefore must be
 * converted to strings for storing on data attributes in the DOM.
 */
export class JSONAttributor<T = any> extends Attributor {
    public add(node: HTMLElement, value: T) {
        if (!value) {
            return false;
        }

        return super.add(node, JSON.stringify(value));
    }

    public value(node: HTMLElement): T {
        return JSON.parse(super.value(node));
    }
}
